import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultFieldset: {
    id: 'lunchFeature.defaultFieldset',
    defaultMessage: 'Default',
  },
  blockTitle: {
    id: 'lunchFeature.blockTitle',
    defaultMessage: 'Lunch du moment',
  },
  image: {
    id: 'lunchFeature.image',
    defaultMessage: 'Image',
  },
  imageDescription: {
    id: 'lunchFeature.imageDescription',
    defaultMessage:
      'Visuel principal du bloc. Format conseillé : portrait 4:5.',
  },
  imageSide: {
    id: 'lunchFeature.imageSide',
    defaultMessage: "Position de l'image",
  },
  imageSideRight: {
    id: 'lunchFeature.imageSideRight',
    defaultMessage: 'Image à droite',
  },
  imageSideLeft: {
    id: 'lunchFeature.imageSideLeft',
    defaultMessage: 'Image à gauche',
  },
  ctaHref: {
    id: 'lunchFeature.ctaHref',
    defaultMessage: 'Lien du bouton principal',
  },
  ctaHrefDescription: {
    id: 'lunchFeature.ctaHrefDescription',
    defaultMessage:
      'URL de destination du bouton principal, par exemple /carte.',
  },
  eyebrow: {
    id: 'lunchFeature.eyebrow',
    defaultMessage: 'Sur-titre',
  },
  heading: {
    id: 'lunchFeature.heading',
    defaultMessage: 'Titre',
  },
  body: {
    id: 'lunchFeature.body',
    defaultMessage: 'Description',
  },
  formula: {
    id: 'lunchFeature.formula',
    defaultMessage: 'Formule',
  },
  serviceInfo: {
    id: 'lunchFeature.serviceInfo',
    defaultMessage: 'Service',
  },
  priceNote: {
    id: 'lunchFeature.priceNote',
    defaultMessage: 'Prix',
  },
  menuNote: {
    id: 'lunchFeature.menuNote',
    defaultMessage: 'Note complémentaire',
  },
  ctaLabel: {
    id: 'lunchFeature.ctaLabel',
    defaultMessage: 'Texte du bouton principal',
  },
  defaultEyebrow: {
    id: 'lunchFeature.defaultEyebrow',
    defaultMessage: 'Lunch du moment',
  },
  defaultHeading: {
    id: 'lunchFeature.defaultHeading',
    defaultMessage: 'Le lunch change chaque semaine.',
  },
  defaultBody: {
    id: 'lunchFeature.defaultBody',
    defaultMessage:
      "Une formule deux services dictée par les arrivages du matin et l'inspiration du chef. La proposition de la semaine est annoncée le mardi matin : téléphonez-nous, nous vous la dévoilons volontiers.",
  },
  defaultFormula: {
    id: 'lunchFeature.defaultFormula',
    defaultMessage: 'Entrée + plat · ou · Plat + dessert',
  },
  defaultServiceInfo: {
    id: 'lunchFeature.defaultServiceInfo',
    defaultMessage: 'Du mardi au vendredi, midi uniquement',
  },
  defaultPriceNote: {
    id: 'lunchFeature.defaultPriceNote',
    defaultMessage: 'À découvrir au téléphone',
  },
  defaultCtaLabel: {
    id: 'lunchFeature.defaultCtaLabel',
    defaultMessage: 'Voir la carte complète',
  },
  formulaLabel: {
    id: 'lunchFeature.formulaLabel',
    defaultMessage: 'Formule',
  },
  serviceLabel: {
    id: 'lunchFeature.serviceLabel',
    defaultMessage: 'Service',
  },
  priceLabel: {
    id: 'lunchFeature.priceLabel',
    defaultMessage: 'Prix',
  },
  eyebrowPlaceholder: {
    id: 'lunchFeature.eyebrowPlaceholder',
    defaultMessage: 'Sur-titre',
  },
  headingPlaceholder: {
    id: 'lunchFeature.headingPlaceholder',
    defaultMessage: 'Titre du bloc lunch',
  },
  bodyPlaceholder: {
    id: 'lunchFeature.bodyPlaceholder',
    defaultMessage: 'Texte d’introduction du lunch',
  },
  formulaPlaceholder: {
    id: 'lunchFeature.formulaPlaceholder',
    defaultMessage: 'Formule proposée',
  },
  serviceInfoPlaceholder: {
    id: 'lunchFeature.serviceInfoPlaceholder',
    defaultMessage: 'Infos de service',
  },
  priceNotePlaceholder: {
    id: 'lunchFeature.priceNotePlaceholder',
    defaultMessage: 'Prix ou note de la semaine',
  },
  menuNotePlaceholder: {
    id: 'lunchFeature.menuNotePlaceholder',
    defaultMessage: 'Note complémentaire optionnelle',
  },
  ctaLabelPlaceholder: {
    id: 'lunchFeature.ctaLabelPlaceholder',
    defaultMessage: 'Texte du bouton principal',
  },
  imagePlaceholder: {
    id: 'lunchFeature.imagePlaceholder',
    defaultMessage: 'Sélectionner une image',
  },
});

export default messages;
